import axiosInstance from "../axiosInterceptor";

export async function emailLogin(body) {
  const response = await axiosInstance.post(`student/login`, body);
  const data = response?.data;
  return data;
}
